export const SENTRY_IGNORED_ERRORS = [
  'UnhandledRejection',
  'InvalidStateError',
  'Request failed with status code 401',
  'VK is not defined',
  'Avoided redundant navigation to current location'
]
